import SearchFilterIcon from "../../assets/icons/filter-icon.svg?react";

export default function ContentFilterButton({
  active,
  onClick,
}: {
  active: boolean;
  onClick?: () => void;
}) {
  return (
    <div className="filter-icon-wrapper w-fit ml-auto pt-[16px] pb-[10px] px-[8px] cursor-pointer">
      <SearchFilterIcon
        className={`filter-icon ${active ? "fill-secondary-raspberry-1" : ""}`}
        onClick={() => onClick && onClick()}
      />
    </div>
  );
}
